import * as Form from '../../../components/form'
import * as RasaInput from '../../../components/rasa-input'
import * as Elasticsearch from '../../../elasticsearch'
export * from '../constants'

export const FETCH_TOP_ARTICLES = 'FETCH_TOP_ARTICLES'
export const FETCH_TOP_ARTICLE_SENDS = 'FETCH_TOP_ARTICLE_SENDS'
export const TOP_ARTICLES_FILTER = 'TOP_ARTICLES_FILTER'
export const FETCH_TOP_ARTICLE_DETAILS = 'FETCH_TOP_ARTICLE_DETAILS'
export const POSTS_SERVER_RESOURCE = '/posts'

export const NUM_TOP_ARTICLES = 100

export const FormConstants = Form.createConstantsMap(TOP_ARTICLES_FILTER)

export const AGGREGATION_TYPES: RasaInput.DropdownOption[] = [
  {
    description: 'Source Name',
    key: Elasticsearch.DocumentFieldNames.SourceName,
  },
  {
    description: 'Publisher',
    key: Elasticsearch.DocumentFieldNames.SiteName,
  },
]



// WEBPACK FOOTER //
// ./src/pages/reports/top-articles/constants.ts